module.exports = __webpack_public_path__ + "static/media/C-Zentrix-logo.e6f4a951.webp";